import { htmlEncode } from '@Common/Helpers/CommonUtils';
import { BaseControl, IControlParameters } from './BaseControl';

export interface ILabelParameters extends IControlParameters {
    caption?: string;
    blockElement?: boolean;
    multiline?: boolean;
    showTooltip?: boolean;
    tooltip?: string;
}

export class Label extends BaseControl<ILabelParameters> {
    private _text: string;

    constructor(param?: ILabelParameters) {
        super(param);
        this._param = $.extend(
            {
                css: null,
                className: '',
                width: '100%',
                height: 'auto',

                caption: '',
                multiline: false,
                showTooltip: false,
                tooltip: null,
                blockElement: false
            },
            param
        );

        this._init();
    }

    protected _init() {
        this._text = this._param.caption;
        const root = document.createElement('label');
        root.className = 'label-control';
        root.textContent = this._text;

        if (this._param.showTooltip) {
            root.setAttribute('title', this._param.caption);
        }
        if (this._param.tooltip) {
            root.setAttribute('title', this._param.tooltip);
        }

        if (this._param.width && this._param.css && this._param.css.maxWidth) {
            this._param.css.maxWidth = this._param.width;
        }

        this._root = $(root);
        this._applyDefaultParam();

        if (this._param.blockElement) {
            root.classList.add('block');
            root.style.lineHeight = this._param.height + 'px';
        }

        if (this._param.multiline) {
            root.style.whiteSpace = 'normal';
        }
        if (this._param.selectable) {
            root.classList.add('selectable');
        }
    }

    public text(txt?: string): string {
        if (arguments.length === 0) {
            return this._text;
        }
        this._text = txt;
        let html = htmlEncode(txt);
        html = html.replaceAll('\n', '<br>');
        this._root.html(html);
        return txt;
    }

    public adjust(width: string | number, height: string | number): void {
        if (this._param.multiline && height) {
            height = 'auto';
        }
        if (this._root && (width || height)) {
            width && this._root.outerWidth(width);
            height && this._root.outerHeight(height);
        }

        if (this._param.blockElement && height) {
            this._root.css({ lineHeight: height + 'px' });
        }
    }

    public html(html?: string): string {
        if (arguments.length === 0) {
            return this._text;
        }

        this._text = html;
        this._root.html(this._text);
        return html;
    }

    public setCaption(caption: string): void {
        this._text = caption;
        this._root.text(caption);
    }
}
